const state = {
    crossTypeIdsInCrossingProgram: null
};

const mutations = {
    SET_CROSS_TYPE_IDS: (state, data) => {
        state.crossTypeIdsInCrossingProgram = data;
    },
};

const actions = {
    async setCrossTypeIdsInCrossingProgram({ commit }, crossTypeIds) {
        commit("SET_CROSS_TYPE_IDS", crossTypeIds); 
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};




// WEBPACK FOOTER //
// ./src/vuex/modules/crossing_program.js